function TeamTab(){
    jQuery(function() {
        let tab = jQuery(".tab-container .gastops__team-member");
        let tabContent = jQuery(".tab-content .gastops__team-member");
        jQuery(tab).click(
            function(){
                let target = jQuery(this).data("team");
                if(jQuery(this).hasClass("active")){
                   return ;
                }
                jQuery(tab).removeClass("active");
                jQuery(tabContent).removeClass("active");               
                jQuery(this).addClass("active");
                //console.log(`.tab-content .gastops__team-member-${target}`);
                jQuery(`.tab-content .gastops__team-member-${target}`).addClass("active");
            }
        );

    });

}

export default TeamTab;